import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

interface UseGetBudgetDataProps {
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getLineItemsByBudgetId = async (budgetId: string) =>
  await axiosAuth.get(`${BUDGET_LINE_ITEMS(budgetId)}`);

const useGetLineItemsByBudgetId = ({
  queryParams,
  budgetId,
}: UseGetBudgetDataProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["line-items-list", budgetId],
    queryFn: () => getLineItemsByBudgetId(budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!budgetId || queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetLineItemsByBudgetId;
